import { FormField, FormFieldProps } from './field'

import { PhoneInput, PhoneInputProps } from '@components/phone-input'

export type PhoneFieldProps = Omit<FormFieldProps<PhoneInputProps>, 'component'>

export function PhoneField(props: PhoneFieldProps) {
  return <FormField {...props} component={PhoneInput} />
}
